import styled from 'styled-components'

const ApiSectionWrapper = styled.section`
  width: 100%;

  > table td:first-child {
    min-width: 240px;
    font-weight: bold;
  }

  em {
    font-weight: normal;
    font-style: italic;
  }
`

export default ApiSectionWrapper
